import { render, staticRenderFns } from "./SecondFactor.vue?vue&type=template&id=3aa48ef0&scoped=true&"
import script from "./SecondFactor.vue?vue&type=script&lang=js&"
export * from "./SecondFactor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aa48ef0",
  null
  
)

export default component.exports